var map = {
	"./1.png": "f130",
	"./2.png": "8cb3",
	"./3.png": "c78d",
	"./4.png": "4296",
	"./5.png": "0236",
	"./6.png": "a2c0",
	"./7.png": "14f5",
	"./8.png": "e872"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "754c";